import TextLink from 'LuxKit/TextLink'
import React from 'react'

type TextLinkProps = React.ComponentProps<typeof TextLink>

interface Props extends Omit<TextLinkProps, 'size' | 'weight' | 'target' | 'children'> {
  /** Visible label for the link. */
  text: string
}

/**
 * Inline external link used inside Société Campaign disclaimer copy.
 * Defaults to Caption Medium / Regular weight and opens in a new tab —
 * matches the type metrics of `SocieteCampaignDisclaimerText`.
 * Pass `colour` to override (e.g. `tier-gold-contrast` on the gold card).
 */
function SocieteCampaignDisclaimerLink({ text, ...rest }: Props) {
  return <TextLink
    size="caption"
    weight="regular"
    target="_blank"
    {...rest}
  >
    {text}
  </TextLink>
}

export default SocieteCampaignDisclaimerLink
